/**
 * Product card: change images on swatch hover (same as click).
 * On hover over a color swatch, updates the card's primary/secondary images.
 * On pointer leave, restores the previously selected variant's images.
 */
(function () {
  const cardRestoreRadio = new WeakMap();
  const SWATCH_SELECTOR = '[type="radio"][data-option-position], [type="radio"][data-variant-media], [type="radio"][data-product-url]';
  const CARD_SELECTOR = 'product-card, .product-card-wrapper';

  function getCard(element) {
    return element?.closest(CARD_SELECTOR) || null;
  }

  function getSwatchControl(labelOrInput) {
    if (!labelOrInput) return null;
    if (labelOrInput.type === 'radio' && labelOrInput.matches(SWATCH_SELECTOR)) return labelOrInput;
    if (labelOrInput.htmlFor) {
      const control = document.getElementById(labelOrInput.htmlFor);
      return control?.type === 'radio' && control.matches(SWATCH_SELECTOR) ? control : null;
    }
    return null;
  }

  function applySwatchSelection(control) {
    if (!control || control.checked) return;
    control.checked = true;
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onPointerOver(e) {
    const label = e.target.closest('label[for]');
    const control = label ? getSwatchControl(label) : getSwatchControl(e.target);
    if (!control) return;

    const card = getCard(control);
    if (!card) return;

    const hasMedia = control.hasAttribute('data-variant-media') || control.hasAttribute('data-product-url');
    if (!hasMedia) return;

    if (control.checked) return;

    if (!cardRestoreRadio.has(card)) {
      const checked = card.querySelector(SWATCH_SELECTOR + ':checked');
      if (checked) cardRestoreRadio.set(card, checked);
    }

    const ensureData = window.CombinedListingsVariantFetch?.ensureVariantData;
    if (ensureData && control.getAttribute('data-fetch-variant') === 'true' && !control.dataset.variantId) {
      ensureData(control).then(function () {
        if (control.hasAttribute('data-variant-media')) applySwatchSelection(control);
      });
    } else {
      applySwatchSelection(control);
    }
  }

  function onPointerOut(e) {
    const card = getCard(e.target);
    if (!card) return;

    const relatedCard = e.relatedTarget ? getCard(e.relatedTarget) : null;
    if (relatedCard === card) return;

    const restore = cardRestoreRadio.get(card);
    if (!restore) return;

    cardRestoreRadio.delete(card);
    if (!restore.checked) {
      restore.checked = true;
      restore.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init() {
    document.addEventListener('pointerover', onPointerOver, { passive: true, capture: true });
    document.addEventListener('pointerout', onPointerOut, { passive: true, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
